import { render } from "./Frecuencia_InterMed.vue?vue&type=template&id=77cf1c09"
import script from "./Frecuencia_InterMed.vue?vue&type=script&lang=js"
export * from "./Frecuencia_InterMed.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__